module.exports = __webpack_public_path__ + "static/media/truck-couch.83539599.svg";